import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ItkTokenManagementServiceLegacy } from '@itk/ng-auth';
import { firstValueFrom } from 'rxjs';
import { ItkAuthenticationService } from '../public-auth/authentication.service';

@Injectable({ providedIn: 'root' })
export class SuperadminGuard {
  constructor(
    private readonly auth: ItkAuthenticationService,
    private readonly tokens: ItkTokenManagementServiceLegacy,
    private readonly router: Router,
  ) {}

  canActivate(): Promise<boolean | UrlTree> {
    return this.auth.isAuthenticated().then((authenticated) => {
      if (!authenticated) return this.router.parseUrl('/login');
      return firstValueFrom(
        this.tokens.getTokenClaims(this.tokens.getAccessToken()),
      ).then((claims) =>
        !('error' in claims) && claims.roles?.includes('superadmin')
          ? true
          : this.router.parseUrl('/'),
      );
    });
  }
}
